<template>
  <div class="mb-2">
    <div class="flex items-center">
      <p class="text-dark-blue">
        {{ subject }}
      </p>
      <slot />
    </div>
    <p class="mb-4 text-xxs font-bold uppercase text-gray-over-dark">
      {{ question.description }}
    </p>
    <textarea
      v-model="answer"
      placeholder="Lorem ipsum dolor sit"
      class="textarea-field focus::border-placeholder-gray mb-4 h-40 w-full rounded-md border border-transparent bg-off-white p-2 px-3 text-sm text-dark-gray placeholder-gray-over-dark hover:border-placeholder-gray focus:bg-white"
      name="message"
      @input="handleChange"
    />
  </div>
</template>

<script>
export default {
  name: 'TextArea',
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    setOnboardingPacket: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
  },
  emits: ['child-check'],
  data() {
    return {
      answer: '',
    };
  },
  computed: {
    stepName() {
      return this.$store.state.formRoutes?.activeStepIdentifier;
    },
  },
  // created() {
  //   let recentAnswer = this.question?.most_recent_previous_answer;
  //   if (recentAnswer) {
  //     this.answer = recentAnswer?.string_value;
  //     this.handleAutoInput();
  //   }
  // },
  watch: {
    stepName: {
      handler(newVal) {
        if (newVal == 'Questions') {
          let recentAnswer = this.question?.most_recent_previous_answer;
          if (recentAnswer) {
            this.answer = recentAnswer?.string_value;
            this.handleAutoInput();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleChange(e) {
      console.log(e.target.value);
      let body = {
        company_question_id: this.question_id,
        string_value: e.target.value,
      };

      this.setOnboardingPacket(body);
      if (this.required) {
        this.answer
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(e.target.value);
    },
    handleAutoInput() {
      let body = null;
      if (this.answer?.length > 0) {
        body = {
          company_question_id: this.question_id,
          string_value: this.answer,
        };
      }

      this.setOnboardingPacket(body);
      if (this.required) {
        this.answer
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.answer);
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (
            child?.evaluation_js?.length > 0 &&
            child?.company_question_id > 0
          ) {
            this.$emit(
              'child-check',
              child.company_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
    },
  },
};
</script>
